import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrlApi } from "../../proxy";
/*--------------------------GET STAKEHOLDER SATISFACTIONS-----------------------------*/
export const getStakeholderSatisfactions = createAsyncThunk(
  "stakeholderSatisfaction/get-stakeholder-satisfactions",
  async () => {
    try {
      const response = await axios.get(`${baseUrlApi}stakeholder_satisfactions`);
      return response?.data;
    } catch (error) {
      throw error;
    }
  },
);
